import * as API from "middleware/api";

export const listConfiguration = () => API.executeAnonymous("/configuration.listConfiguration");
export const listPreLoginConfiguration = () => API.executeAnonymous("/configuration.listConfiguration.preLogin");
export const listPostLoginConfiguration = () =>
    API.executeWithAccessToken("/configuration.listConfiguration.postLogin");

export default listConfiguration;
